'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = init;

var _Observable = require('rxjs/Observable');

require('rxjs/add/observable/fromEvent');

require('rxjs/add/operator/filter');

require('rxjs/add/operator/map');

var searchEl = void 0,
    isActive = void 0,
    searchBox = void 0,
    filtersBox = void 0;

function init() {
    searchEl = document.querySelector('.js-development-search');
    if (!searchEl) {
        return;
    }

    searchBox = searchEl.querySelector('.c-development-search__search');
    filtersBox = searchEl.querySelector('.c-development-search__more-filters');

    isActive = false;

    calcHeight();
    updateHeight();

    searchEl.classList.add('transition');

    var click = _Observable.Observable.fromEvent(searchEl, 'click');
    click.filter(function (el) {
        return el.target.classList.contains('js-development-search-open') || el.target.classList.contains('js-development-search-close');
    }).map(function (el) {
        return el.preventDefault();
    }).subscribe(toggleFilters);
}

function toggleFilters() {
    if (searchEl.classList.contains('is-active')) {
        searchEl.classList.remove('is-active');
        isActive = false;
    } else {
        searchEl.classList.add('is-active');
        isActive = true;
    }

    updateHeight();
}

function updateHeight() {
    if (isActive) {
        searchEl.style.height = filtersBox.dataset.height + 'px';
    } else {
        searchEl.style.height = searchBox.dataset.height + 'px';
    }
}

function calcHeight() {
    var boxes = [searchBox, filtersBox];
    boxes.forEach(function (box) {
        if (!box.firstElementChild) {
            return;
        }

        var _box$firstElementChil = box.firstElementChild.getBoundingClientRect(),
            height = _box$firstElementChil.height;

        box.dataset.height = height;
    });
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/development-search.js
// module id = ./resources/assets/js/src/ui/development-search.js
// module chunks = 0